import { useContext } from "react";
import { DemandResponseConfigurationContext } from "./DemandResponseContextProvider";

const useDemandResponseContext = () => {
  return useContext(DemandResponseConfigurationContext);
};

export default useDemandResponseContext;
